import { render, staticRenderFns } from "./SupportIcon.vue?vue&type=template&id=2e108a36&"
import script from "./SupportIcon.vue?vue&type=script&lang=js&"
export * from "./SupportIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports